import { useEffect, useState } from 'react';
import { Logo, NotificationMessage } from 'components';
import { StyledHeader, HeaderContainer } from './styled';
import { useMediaQuery } from '@material-ui/core';
import { BREAKPOINTS } from 'utils/styles/breakpoints';
import { DesktopMenu } from './DesktopMenu';
import { BurgerMenu } from './BurgerMenu';
import { NAV_ITEM, PRIVATE_NAV_ITEM } from './data';
import { useLocation } from 'react-router-dom';
import { serviceUrl } from 'utils/helpers';

export const Header = ({ isAuth }) => {
  const [isSystem, setIsSystem] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const isMobile = useMediaQuery(BREAKPOINTS.lg);
  const location = useLocation();

  const routes = isAuth() && !isSystem ? PRIVATE_NAV_ITEM : NAV_ITEM;

  useEffect(() => {
    setIsSystem(serviceUrl(location.pathname));
  }, [location.pathname]);

  return (
    <StyledHeader>
      <HeaderContainer>
        <Logo setIsOpen={setIsOpen} />
        {isMobile ? (
          <BurgerMenu
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            routes={routes}
            isAuth={isAuth}
          />
        ) : (
          <DesktopMenu routes={routes} isAuth={isAuth} />
        )}
        <NotificationMessage />
      </HeaderContainer>
    </StyledHeader>
  );
};
